import React from "react";
import ComingSoon from "../components/ComingSoon";

const CampusLife = () => (
  <ComingSoon
    title="Campus Life · Coming Soon"
    description="Our campus life experience — clubs, events, study spaces and student community — will be revealed ahead of our 2026 intake. Subscribe to be the first to know."
    testId="campus-life-coming-soon"
  />
);

export default CampusLife;
